<template>
    <div class="cs-student-course-container">
        <el-row>
            <el-col>
                <el-row>
                    <el-col :span="24">
                        <strong><label class="el-form-item__label float-left">老师：</label></strong> 
                        <label class="el-form-item__label float-left" v-text="this.teacherName"></label>
                    </el-col>
                </el-row>
                <el-row class="grid-content">
                    <el-col>
                        <courseCalendar :options="{
                            start:GLOBAL.courseScheduleSetting.start,
                            end:GLOBAL.courseScheduleSetting.end}"
                          v-loading="loading" :schedules="courseSchedules"></courseCalendar>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>


<style lang="scss" scoped>
.cs-student-course-container {
  padding: 10px 40px 10px 40px;

  .grid-content {
    margin-top: 0;
    .cs-schedule-buttonContainer {
      text-align: right;
    }
  }
  label {
    &.el-form-item__label {
      line-height: 20px;
    }
  }
  button {
    &.el-button--text {
      color: black;
      font-size: 15px;
    }
  }
}
</style>

<script>
import courseCalendar from "./courseCalendar";
import { getColorList } from "../config/mUtils";
import {
  getPlanCourseList
} from "../service/speedupCourse.service";

export default {
  data() {
    return {
      loading: false,
      courseSchedules: [],
      teacherName:"",
      teacherId: 0,
      termId:0,
      plan:null
    };
  },
  props: {
    data: {}
  },
  components: {
    courseCalendar
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData(){
      if (!this.data || (this.data && !this.data.teacherId)){
        this.courseSchedules = [];
        return;
      }

      if(this.data){
        if (this.data.plan){
          this.plan = this.data.plan;
        } else{
          this.plan = null;
        }

        this.teacherName = this.data.teacherName;
        this.teacherId = this.data.teacherId;
        this.termId = this.data.termId;
      }
      this.loadCourseSchedule();
    },
    loadCourseSchedule() {
     
      // if (!this.plan ){
      //   this.courseSchedules = [];
      //   return;
      // }
      let planId = 0;
      if (!!this.plan){
        planId = this.plan.Id;
      }
      this.loading = true;
      getPlanCourseList(this.termId, planId, this.teacherId, true).then(result=>{
         if (!!result && result.success) {
           this.loadCourseList(result.data);
         }
          this.loading = false;
      });
      
    
    },
    loadCourseList(courseListAll){
       let scheduleList = [];
      //if (this.plan && this.plan.courseList) {
        //let courseList = this.plan.courseList.filter(i => i.TeacherId == this.teacherId);
        let courseList = courseListAll.filter(i => i.TeacherId == this.teacherId);
        let colorList = getColorList();

        courseList.forEach((element, index) => {
          let dayofweek = element.DayOfWeek;
          if (dayofweek == 0) {
            dayofweek = 7;
          }
          let courseName = element.CourseName;
          if (element.CourseClass > 0) {
            courseName += "-分班" + element.CourseClass;
          }
          let desc =
            courseName +
            "<br/>" +
            element.StudentCount +
            "人" +
            "<br/>" +
            element.TeacherName;
          let item = {
            color: colorList[index],
            starttime: element.StartTimeText,
            endtime: element.EndTimeText,
            dayofweek: dayofweek,
            title: desc,
            text: "",
            tooltipText: element.StartTimeText + " - " + element.EndTimeText,
            keyValue: index,
            dataId: index
          };
          scheduleList.push(item);
        });
      //}
      this.courseSchedules = scheduleList;
    }
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>
 



// WEBPACK FOOTER //
// src/components/teacherCourseReview.vue